module.exports = __webpack_public_path__ + "img/mtf_trnava.4cdc704c.jpg";